module.exports = __webpack_public_path__ + "img/notifications.ae869be2.png";